<template>
  <form @submit.prevent="vLaunchStockResearch">
    <div class="stock-research">
      <div class="form-field">
        <label>{{$_('product_reference')}}*</label>
        <SelectAutocomplete
          :placeholder="$_('model_reference')"
          delay="300"
          :itemoption="['TMOD', 'TMOD']"
          @autocomplete:selected="vSelectedStore('fmod', $event.TMOD)"
          :ajax="true"
          :func="vSearchProduct"
        />
      </div>
       <div class="form-field">
        <label>{{$_('size')}}*</label>
        <Select
          :placeholder="$_('size')"
          :itemoption="['TTAIL', 'TTAIL']"
          :data="aSize"
          :search="true"
          @select-change="vSelectedStore('ptail', $event.item)"
          :resetselect="nRender"
        />
      </div>
      <div class="form-field" v-show="getRefValue !== ''">
        <label>{{$_('color_group')}}</label>
        <Select
          :placeholder="$_('color_group')"
          :itemoption="['TCCOL', 'TLIB_CCOL']"
          :data="aColFamily"
          :search="true"
          @select-change="vSelectedStore('col_family', $event.item)"
          :resetselect="nRender"
        />
      </div>
      <div class="form-field">
        <label>{{$_('color_reference')}}*</label>
        <Select
          :placeholder="$_('color_reference')"
          :itemoption="['TCOL', 'TCOL']"
          :data="aCol"
          :search="true"
          @select-change="vSelectedStore('pcol', $event.item)"
          :resetselect="nRender"
        />
      </div>
      <div class="form-field">
        <button class="btn">{{$_('research_button')}}</button>
      </div>
    </div>
  </form>
</template>

<script>
import SelectAutocomplete from "@/common/components/widget/Autocomplete/SelectAutocomplete";
import Select from "@/common/components/widget/Select";
import stockService from '../services/stockService.js';

export default {
  name: 'RateResearch',
  data() {
    return {
      aSize: Array(),
      aColFamily: Array(),
      aCol: Array(),
      nRender: false
    }
  },
  components: {
    SelectAutocomplete,
    Select
  },
  computed: {
    getRefValue() {
      return this.$store.getters['stock/get_fmod'];
    },
    getSizeValue() {
      return this.$store.getters['stock/get_ptail'];
    },
    getColFamilyValue() {
      return this.$store.getters['stock/get_col_family'];
    }
  },
  methods: {
    vLaunchStockResearch() {
      this.$store.dispatch('stock/LAUNCH_RESEARCH', {launch: true});
      this.$store.dispatch('stock/SELECT', {key: 'reset_stock_list', value: true});
    },
    vSelectedStore(key, value) {
      if(key === 'fmod') {
        this.nRender = true;
        value = value.toUpperCase();
      }
      setTimeout(() => {
        this.$store.dispatch('stock/SELECT', {key, value});
        this.nRender = false;
      }, 300);
    },
    vSearchProduct(query) {
      return stockService.getProduct(query)
      .then(res => {
        if(res.data.DS_O.OUT !== undefined) {
          return res.data.DS_O.OUT
        }
      })
      .catch(err => {
        console.error(err);
      }) 
    },
  },
  watch: {
    getRefValue(val) {
      stockService.getSize(val).then(res => {
        if(res.data.DS_O.OUT !== undefined) {
          this.aSize = res.data.DS_O.OUT
        }
      }).catch(err => {
        console.error(err);
      });

      stockService.getColFamily(val).then(res => {
        if(res.data.DS_O.OUT !== undefined) {
          this.aColFamily = res.data.DS_O.OUT
        }
      }).catch(err => {
        console.error(err);
      });
    },
    getSizeValue(val) {
      
      let pmod = this.$store.getters['stock/get_fmod'];
      
      stockService.getCol(pmod, val).then(res => {
        if(res.data.DS_O.OUT !== undefined) {
          this.aCol = res.data.DS_O.OUT
        }
      }).catch(err => {
        console.error(err);
      });
    },
    getColFamilyValue(val) {
      let pmod = this.$store.getters['stock/get_fmod'];
      let ptail = this.$store.getters['stock/get_ptail'];
      
      stockService.getCol(pmod, ptail, val).then(res => {
        if(res.data.DS_O.OUT !== undefined) {
          this.aCol = res.data.DS_O.OUT
        }
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
.stock-research {
  background-color: #f5f5f5;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}
.form-field {
  margin: 5px;
}
label {
  padding-left: 20px;
}
/deep/
.select-box {
  margin: 0px;
}

/deep/
.select-box-dropdown::-webkit-scrollbar {
  width: 10px;
  display: block; 
}
/deep/
.select-box-dropdown::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
/deep/
.autocomplete .autocomplete-dropdown::-webkit-scrollbar {
  width: 10px;
  display: block; 
}
/deep/
.autocomplete .autocomplete-dropdown::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
/deep/
.autocomplete .autocomplete-field input {
  text-transform: uppercase;
}
</style>